"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.staticRenderFns = exports.render = void 0;
var render = exports.render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("page", {
    attrs: {
      "return-menu": "/farm-management/dashboard",
      menu: _vm.page.children,
      subtitle: _vm.page.meta.title
    },
    scopedSlots: _vm._u([{
      key: "context",
      fn: function fn() {
        var _vm$selectedLot$roots, _vm$selectedLot$scion;
        return [_c("section", {
          staticClass: "graft-success-rate-page"
        }, [_c("header", {
          staticClass: "page-header"
        }, [_c("h1", {
          staticClass: "page-title"
        }, [_vm._v("\n          Índice de Pegamento\n        ")]), _vm._v(" "), _vm.selectedLot ? _c("b-button", {
          staticClass: "plant-nursery-primary-btn",
          attrs: {
            type: "is-primary"
          },
          on: {
            click: _vm.clearSelection
          }
        }, [_c("span", {
          staticClass: "icon"
        }, [_c("i", {
          staticClass: "icon-ic_voltar"
        })]), _vm._v(" "), _c("span", [_vm._v("Voltar para seleção")])]) : _vm._e()], 1), _vm._v(" "), !_vm.selectedLot ? _c("div", {
          staticClass: "page-content"
        }, [_c("h3", {
          staticClass: "section-title"
        }, [_vm._v("\n          Selecione um lote enxertado para registrar mortalidade da copa\n        ")]), _vm._v(" "), _c("LotsList", {
          attrs: {
            lots: _vm.lots,
            "is-loading": _vm.isLoadingLots
          },
          on: {
            onSearchChange: _vm.handleLotsSearch
          },
          model: {
            value: _vm.selectedLot,
            callback: function callback($$v) {
              _vm.selectedLot = $$v;
            },
            expression: "selectedLot"
          }
        })], 1) : _c("div", {
          staticClass: "page-content"
        }, [_c("div", {
          staticClass: "selected-lot-info"
        }, [_c("h3", {
          staticClass: "section-title"
        }, [_vm._v("\n            Lote selecionado: " + _vm._s(_vm.selectedLot.code) + "\n          ")]), _vm._v(" "), _c("p", {
          staticClass: "lot-details"
        }, [_c("strong", [_vm._v("Tipo:")]), _vm._v(" " + _vm._s(_vm.formatLotType(_vm.selectedLot.type)) + " |\n            "), _c("strong", [_vm._v("Cavalo:")]), _vm._v(" " + _vm._s(((_vm$selectedLot$roots = _vm.selectedLot.rootstock) === null || _vm$selectedLot$roots === void 0 ? void 0 : _vm$selectedLot$roots.name) || "--") + " |\n            "), _c("strong", [_vm._v("Copa:")]), _vm._v(" " + _vm._s(((_vm$selectedLot$scion = _vm.selectedLot.scion) === null || _vm$selectedLot$scion === void 0 ? void 0 : _vm$selectedLot$scion.name) || "--") + "\n          ")])]), _vm._v(" "), _c("b-message", {
          staticClass: "info-message",
          attrs: {
            type: "is-info",
            "has-icon": ""
          }
        }, [_vm._v("\n          Ao registrar a mortalidade da copa, as quantidades selecionadas serão subtraídas do lote\n          atual. Um novo lote de reenxertia será criado apenas com o cavalo (porta-enxerto) e sem\n          copa.\n        ")]), _vm._v(" "), _c("form", {
          on: {
            submit: function submit($event) {
              $event.preventDefault();
              return _vm.submitForm.apply(null, arguments);
            }
          }
        }, [_c("div", {
          staticClass: "form-section"
        }, [_c("h3", {
          staticClass: "section-title"
        }, [_vm._v("\n              Informações da mortalidade\n            ")]), _vm._v(" "), _c("div", {
          staticClass: "form-row"
        }, [_c("b-field", {
          staticClass: "form-field",
          attrs: {
            label: "Data do registro"
          }
        }, [_c("b-datepicker", {
          attrs: {
            placeholder: "Selecione a data",
            icon: "calendar-today",
            "max-date": new Date(),
            "trap-focus": false,
            required: ""
          },
          model: {
            value: _vm.form.reportAt,
            callback: function callback($$v) {
              _vm.$set(_vm.form, "reportAt", $$v);
            },
            expression: "form.reportAt"
          }
        })], 1), _vm._v(" "), _c("b-field", {
          staticClass: "form-field",
          attrs: {
            label: "Descrição (opcional)"
          }
        }, [_c("b-input", {
          attrs: {
            placeholder: "Descrição da mortalidade da copa"
          },
          model: {
            value: _vm.form.description,
            callback: function callback($$v) {
              _vm.$set(_vm.form, "description", $$v);
            },
            expression: "form.description"
          }
        })], 1)], 1)]), _vm._v(" "), _c("div", {
          staticClass: "form-section"
        }, [_c("LotInventorySelector", {
          attrs: {
            inventories: _vm.selectedLot.inventories || [],
            label: "Quantidades com falha na enxertia",
            "quantity-label": "Quantidade",
            "quantity-placeholder": "Qtd.",
            "empty-message": "Este lote não possui inventários disponíveis.",
            strength: ""
          },
          model: {
            value: _vm.form.failedGraft,
            callback: function callback($$v) {
              _vm.$set(_vm.form, "failedGraft", $$v);
            },
            expression: "form.failedGraft"
          }
        })], 1), _vm._v(" "), _c("div", {
          staticClass: "form-actions"
        }, [_c("b-button", {
          staticClass: "plant-nursery-primary-btn",
          attrs: {
            "native-type": "submit",
            type: "is-primary",
            loading: _vm.isSubmitting,
            disabled: _vm.isSubmitting
          }
        }, [_vm._v("\n              Registrar mortalidade da copa\n            ")]), _vm._v(" "), _c("b-button", {
          attrs: {
            type: "is-text",
            disabled: _vm.isSubmitting
          },
          on: {
            click: _vm.handleCancel
          }
        }, [_vm._v("\n              Cancelar\n            ")])], 1)])], 1)])];
      },
      proxy: true
    }])
  });
};
var staticRenderFns = exports.staticRenderFns = [];
render._withStripped = true;